import { Receipt } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconReceipt(props: Readonly<IconWrapperProps>) {
  return (
    <IconWrapper {...props}>
      <Receipt />
    </IconWrapper>
  );
}
